
import Cookies from 'js-cookie';

import { useToast } from '@chakra-ui/react';

export const PAYMENT_CARD = '1';
export const PAYMENT_BANK_TRANSFER = '2';
export const PAYMENT_CODE = '3';

export const PRICE_ONLINE_PHYSICAL_COPY = 790;
export const DPH_VALUE = 12;

export const fieldNameAndLabels = {
    email: {name: 'email', label: 'E-mail'},
    password: {name: 'password', label: 'Heslo'},
    telephone: {name: 'telephone', label: 'Telefonní číslo'},
    name: {name: 'name', label: 'Jméno'},
    surname: {name: 'surname', label: 'Příjmení'},
    ico: {name: 'ico', label: 'IČO'},
    dic: {name: 'dic', label: 'DIČ'},
    companyName: {name: 'companyName', label: 'Název společnosti'},
    street: {name: 'street', label: 'Ulice a číslo popisné'},
    city: {name: 'city', label: 'Město'},
    zipCode: {name: 'zipCode', label: 'PSČ'},
    deliveryDifferentAddress: {name: 'deliveryDifferentAddress', label: 'Doručit časopis na jinou než fakturační adresu'},
    asCompany: {name: 'asCompany', label: 'Nakupuji na firmu'},
    nameDelivery: {name: 'nameDelivery', label: ' Jméno a příjmení'},
    streetDelivery: {name: 'streetDelivery', label: 'Ulice'},
    cityDelivery: {name: 'cityDelivery', label: 'Město'},
    zipCodeDelivery: {name: 'zipCodeDelivery', label: 'PSČ'},
    subscriptionType: {name: 'subscriptionType', label: 'Typ předplatného'},
    paymentType: {name: 'paymentType', label: 'Způsob platby'},
    subscriptionActivationCode: {name: 'subscriptionActivationCode', label: 'Kód'},
    antiSpam: {name: 'antiSpam', label: 'Anti-spam: Doplňte aktuální rok'}
}

export const emptyFormData = {
    email: '',
    password: '',
    telephone: '',
    name: '',
    surname: '',
    asCompany: '',
    ico: '',
    dic: '',
    companyName: '',
    street: '',
    city: '',
    zipCode: '',
    deliveryDifferentAddress: '',
    nameDelivery: '',
    streetDelivery: '',
    cityDelivery: '',
    zipCodeDelivery: '',
    subscriptionType: '',
    paymentType: '',
    subscriptionActivationCode: '',
    antiSpam: '',
}


export const emptyFormDataPurchase = {
    email: '',
    password: '',
    telephone: '',
    name: '',
    asCompany: '',
    ico: '',
    dic: '',
    companyName: '',
    street: '',
    city: '',
    zipCode: '',
    deliveryDifferentAddress: '',
    nameDelivery: '',
    streetDelivery: '',
    cityDelivery: '',
    zipCodeDelivery: '',
    subscriptionType: '',
    paymentType: '',
    subscriptionActivationCode: ''
}

export const emptyFormDataCodeActivation = {
    email: '',
    password: '',
    telephone: '',
    name: '',
    surname: '',
    paymentType: PAYMENT_CODE,
    subscriptionActivationCode: ''
}


/**
 *
 * @param hash
 * @param orderId
 */
export const addHashOrderPairsToCookies = (hash: string, orderId: string): void => {

    let cookieData = Cookies.get('baskets');
    const parsedData = cookieData ? JSON.parse(cookieData) : {};

    parsedData[hash] = orderId;

    Cookies.set('baskets', JSON.stringify(parsedData), { expires: 30 }); // 14 dnu
};

/**
 *
 * @param hash
 */
export const checkIfHashExistsInCookies = (hash: string): boolean => {

    let cookieData = Cookies.get('baskets');
    const parsedData = cookieData ? JSON.parse(cookieData) : {};

    return parsedData.hasOwnProperty(hash);
};

/**
 *
 * @param orderId
 */
export const getHashByOrderId = (orderId: string): string | null => {
    // Retrieve existing cookies or initialize an empty object
    let cookieData = Cookies.get('baskets');
    const parsedData = cookieData ? JSON.parse(cookieData) : {};

    // Find and return the hash that corresponds to the given orderId
    for (const [hash, id] of Object.entries(parsedData)) {
        if (id === orderId) {
            return hash;
        }
    }
    return null; // Return null if no match is found
};

export function isNotEmptyObj(obj : any) {
    // Check if it's an object and has keys
    if (typeof obj === 'object' && obj !== null && Object.keys(obj).length > 0) {
        return true; // Object is not empty
    }
    return false; // Object is empty
}

export const swapDotForComma = (value : any) => {
    // Convert to string if the value is a number
    if (typeof value === "number") {
        value = value.toString();
    }
    // Perform the replacement
    return value.replace(/\./g, ',');
};